<template>
  <el-drawer
    :title="title"
    :visible.sync="drawerVisible"
    :direction="direction"
    :close-on-click-modal="closeOnClickModal"
    :size="size"
    @close="handleClose"
  >
    <!-- 内容区域 -->
    <div :style="contentStyle">
      <slot></slot>
    </div>

    <!-- 底部按钮区域 -->
    <div v-if="showFooter" :style="footerStyle">
      <slot name="footer">
        <el-button @click="handleCancel">{{ cancelText }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ confirmText }}</el-button>
      </slot>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'CommonDrawer',
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 滑出方向
    direction: {
      type: String,
      default: 'rtl'
    },
    // 点击遮罩是否可关闭
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    // 抽屉宽度
    size: {
      type: String,
      default: '30%'
    },
    // 是否显示底部
    showFooter: {
      type: Boolean,
      default: true
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: '取 消'
    },
    // 确定按钮文字
    confirmText: {
      type: String,
      default: '确 定'
    },
    // 内容区域底部间距（为底部按钮预留空间）
    contentPaddingBottom: {
      type: String,
      default: '80px'
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    contentStyle() {
      return {
        padding: '0 20px',
        height: 'calc(100vh - 120px)',
        overflowY: 'auto',
        paddingBottom: this.showFooter ? this.contentPaddingBottom : '20px'
      };
    },
    footerStyle() {
      return {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        padding: '20px',
        borderTop: '1px solid #e8e8e8',
        background: '#fff',
        textAlign: 'right'
      };
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleCancel() {
      this.$emit('cancel');
      this.drawerVisible = false;
    },
    handleConfirm() {
      this.$emit('confirm');
    }
  }
};
</script>

<style scoped>
</style>
